// removed by extract-text-webpack-plugin
module.exports = {"container":"no-guest-chat-page__container__WYc66","fixed-container":"no-guest-chat-page__fixed-container__1kAE4","content":"no-guest-chat-page__content__2bWye","text":"no-guest-chat-page__text__HeRo7","download-app-button-container":"no-guest-chat-page__download-app-button-container__FIr3w"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/no-guest-chat-page.scss
// module id = 1400
// module chunks = 1